import { Component, Mixins, Prop } from 'vue-property-decorator';
import ResultPage from '@/components/result-page';
import { RouterV2Enum } from '@/router/router-names';
import { PreApplyResultPo } from '@/po/preApplyResult';
import FirstActiveApi from '@/api/active';
import InterestFree from '@/components/interest-free';
import type { PreQueryChannleProduct } from '@/model/preApplyResult';
import { formatCreditAmount } from '@/views_v2/home/components/utils';
import RouterHelper from '@/shared/utils/routerHelper';
import { getHomePath } from '@/router/utils';
import platform from '@/shared/utils/platform';
import MyMixns from '../mixins';

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const style: Dictionary = require('./index.module.scss');

@Component({
  name: 'ApplySuccess',
})
export default class ApplySuccess extends Mixins(MyMixns) {
  // 授信结果数据
  @Prop(Object) readonly applyResultSuccess!: PreQueryChannleProduct.Infomation;

  // 获取结果成功信息
  private get applyResult(): PreApplyResultPo.Info {
    return this.applyResultSuccess.userProductCreditResultVO;
  }

  // 倒计时结束后自动跳转提现页
  private leftTime = 3;

  private countDownInterval: NodeJS.Timer | null = null;

  // 是否显示首期免息弹窗
  private showCouponDialog = false;

  private async created() {
    if (platform.isAlipayMini || platform.isDingTalk) {
      const couponData = await FirstActiveApi.getHaveCoupon(
        String(this.applyResult.productId),
      );

      if (couponData) {
        this.showCouponDialog = true;
      } else {
        this.countDownInterval = setInterval(this.countDown.bind(this), 1000);
      }
    } else {
      this.countDownInterval = setInterval(this.countDown.bind(this), 1000);
    }

    // 授信成功页，返回直接回到首页
    RouterHelper.setBackPath(getHomePath());
  }

  // 清除定时器
  private destroyed() {
    if (this.countDownInterval) {
      clearInterval(this.countDownInterval);
      this.countDownInterval = null;
    }
  }

  private countDown() {
    this.leftTime -= 1;

    if (this.leftTime <= 0) {
      this.$ubtPageButton('臻有钱_资料审核完成_提现跳转');

      if (this.countDownInterval) {
        clearInterval(this.countDownInterval);
        this.countDownInterval = null;
      }

      this.$router.replace({
        path: RouterV2Enum.applyProduct,
        query: {
          commodityId: String(this.applyResult.productId),
        },
      });
    }
  }

  private onApply() {
    this.$ubtPageButton('臻有钱_资料审核完成_立即提现');

    this.$router.replace({
      path: RouterV2Enum.applyProduct,
      query: {
        commodityId: String(this.applyResult.productId),
      },
    });
  }

  private renderTip() {
    const { availableAmount } = this.applyResult;

    return (
      <p class={style.header_title}>
        <p class={style.moneyUp}>
          <span>可提现额度</span>
        </p>
        <div class={style.moneyTotal}>
          <span class={style.unit}>￥</span>
          {formatCreditAmount(Number(availableAmount || 0).toFixed(2))}
        </div>
      </p>
    );
  }

  private renderTitle() {
    return (
      <p class={style.newTitleIcon}>审核通过</p>
    );
  }

  // 首提弹窗
  private onCloseDialog() {
    this.showCouponDialog = false;
    this.countDownInterval = setInterval(this.countDown.bind(this), 1000);

    this.$ubtPageButton('臻有钱_首期免息弹窗_关闭');
  }

  private render() {
    const { productId } = this.applyResult;

    const resultProps = {
      attrs: {
        status: 'success',
        title: this.renderTitle(),
        subTitle: this.renderTip(),
      },
    };

    return (
      <ResultPage {...resultProps}>
        <InterestFree
          v-show={this.showCouponDialog}
          commodityId={productId}
          couponTip={String(productId) !== '3200'} /* 分期乐 */
          onClose={this.onCloseDialog.bind(this)}
        />

        {this.applyResult.productName && (<div class={style.productName}>
          <span class={style.left}>审核机构</span>
          <span class={style.right}>{this.applyResult.productName}</span>
        </div>)}

        <section class={style.bank}>
          <span>{this.leftTime}</span>
          <span>s</span>
          <span>后</span>
          <span
            onClick={() => this.onApply()}
          >
            立即提现
          </span>
        </section>
      </ResultPage>
    );
  }
}
